
export function matchPublicUrl(inputStr:string) {
    return (inputStr.endsWith("www.beachnow.it") || inputStr.endsWith("app2.beachnow.it") || inputStr.endsWith("/"));
}
